<template>
    <el-button :type="type" v-bind="$attrs" v-on="$listeners" icon="fa fa-fw fa-refresh">
        刷新
    </el-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary'
        }
    },
    methods: {
    }
}
</script>
